var swiperRecursosGratuitosCarouselSocialMediaCards = new Swiper(".swiperRecursosGratuitosCarouselSocialMediaCards", {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 6,
    navigation: {
        prevEl: ".recursos-gratuitos-carousel-social-media-cards .swiper-button-prev",
        nextEl: ".recursos-gratuitos-carousel-social-media-cards .swiper-button-next",
    },
    pagination: {
        el: ".recursos-gratuitos-carousel-social-media-cards .swiper-pagination",
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 5,
    },
    breakpoints: {
        440: {
            slidesPerView: 1.2,
        },
        570: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 2.3,
        },
        1024: {
            slidesPerView: 3,
        },
        1320: {
            slidesPerView: 3,
        },
    }    
  });



